module.exports = __webpack_public_path__ + "img/172420-förhöjd.96a9c455.png";